import { createReducer } from '@reduxjs/toolkit';
import { Nullable } from 'modules/types/common';
import * as providersActions from 'store/amwell/activeConsumer/providers/actions';
import * as storageActions from 'store/amwell/storage/actions';
import { FirstAvailableConfiguration } from './types';
import * as actions from './actions';
import { hasFirstAvailable } from './mappers';
import { RESET_AMWELL_ACTIVITY } from '../actions';

export type SpecialtiesState = Readonly<{
  hasFirstAvailable: boolean;
  details: {
    data: Nullable<FirstAvailableConfiguration>;
    loading: boolean;
    error: Nullable<Error>;
  };
}>;

export const specialtiesInitialState: SpecialtiesState = {
  hasFirstAvailable: false,
  details: {
    data: null,
    loading: false,
    error: null
  }
};

export const specialtiesReducer = createReducer(specialtiesInitialState, {
  [actions.GET_FIRST_AVAILABLE]: state => {
    state.details.loading = true;
    state.details.error = null;
  },
  [actions.GET_FIRST_AVAILABLE_FAIL]: (state, action) => {
    state.details.error = action.error;
    state.details.loading = false;
  },
  [actions.GET_FIRST_AVAILABLE_SUCCESS]: (state, action) => {
    state.details.data = action.payload;
    state.details.loading = false;
  },
  [actions.HAS_FIRST_AVAILABLE]: state => {
    state.hasFirstAvailable = false;
  },
  [actions.HAS_FIRST_AVAILABLE_SUCCESS]: (state, action) => {
    state.hasFirstAvailable = hasFirstAvailable(action.payload);
  },
  [providersActions.GET_PROVIDER_DETAIL_SUCCESS]: state => {
    state.details.data = null;
  },
  // Web Amwell Session Restore
  [storageActions.GET_STORAGE_SUCCESS]: (state, action) => {
    state.details.data = action.payload.specialty;
  },
  [RESET_AMWELL_ACTIVITY]: () => specialtiesInitialState
});
